import { useNavigate, useParams } from 'react-router-dom';
import { TableWidget } from '../../../components/table-widget/TableWidget';
import { useOperatorsState } from '../../../services/OperatorsList';
import { MonitorSmartphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import './DevicesCpe.scss';

type Props = {
  summaryData: any;
  isActive: (link:string) => void;
};

export const DevicesCpe = (props: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { operatorList, loggedUserData } = useOperatorsState();
  const { operatorId, cpeId } = useParams();

  function goToDevicePage(rowData: any, highlightCve?: boolean) {
    window.localStorage.setItem('currentNav','Accounts')
    props?.isActive('Accounts');

    navigate(
      `/operators/${operatorId}/cpe/${cpeId}/d/${rowData.key.ID || rowData.key.deviceId}/accountsPage`,
      highlightCve ? { state: { id: 'high-cve' } } : undefined
    );
  }

  return (
    <section className="cp-devices">
      <header className="cp-devices-hd">
        <span className="cp-devices-icon" aria-hidden="true">
          <MonitorSmartphone size={16} strokeWidth={1.75} />
        </span>
        <div className="cp-devices-hd-text">
          <h2 className="bd-h2">{t('cpeTabs.devices.title')}</h2>
          <span className="bd-meta">{t('cpeTabs.devices.description')}</span>
        </div>
      </header>
      <div className="cp-devices-table">
        <TableWidget
          hasSearch={true}
          title={t('cpeTabs.devices.tableTitle')}
          subTitle={t('cpeTabs.devices.tableSubtitle')}
          onRowSelect={goToDevicePage}
          url={`op/${operatorId}/cpe/${cpeId}/device_table`}
          countPerPage={10}
        />
      </div>
    </section>
  );
};
